/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Tab_Audio_DescriptionsInputs */



/**
* | output |
* | --- |
* | "Audio Descriptions" |
*
* @param {Preset_Manager_Tab_Audio_DescriptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_tab_audio_descriptions = /** @type {((inputs?: Preset_Manager_Tab_Audio_DescriptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Tab_Audio_DescriptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Descriptions audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizioni audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиоописания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripciones de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição de áudio")
	return /** @type {LocalizedString} */ ("Audio Descriptions")
});